<script setup lang="ts">
import type { MetricItem } from '@/types/business'
defineProps<{ item: MetricItem }>()
</script>
<template>
  <article class="metric-card" :class="`tone-${item.tone}`">
    <div class="metric-card__label">{{ item.label }}</div>
    <strong>{{ item.value }}</strong>
    <span>{{ item.change }}</span>
  </article>
</template>
